import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as documentService from "../../services/documentService";
import { handleApiError } from "../storeEffects";
import { DocumentAction, documentFailure, documentSuccess } from "./storeDocument";

export type DocumentThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, DocumentAction>

export const getDocumentPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return documentService.getDocumentPage()
        .then(
            documentPage => {
                dispatch(documentSuccess(documentPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(documentFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};